import React, { useCallback, useState } from "react";
import MessagePartnerModal from "./modals/MessagePartnerModal";
import { Box, Button } from "@mui/material";
import styles from "../../../styles/components/video.module.scss";
import assest from "../../../json/assest";

const VideoMessageSection = ({ data }) => {
  const [openPartnerMessage, setOpenPartnerMessage] = useState(false);

  const closePartnerModal = useCallback(() => {
    setOpenPartnerMessage(false);
  }, []);

  return (
    <>
      <MessagePartnerModal
        data={data}
        open={openPartnerMessage}
        onClose={closePartnerModal}
      />
      {data.status == 3 && (
        <Box className={styles.selectWrapper}>
          {data.buyer ? (
            <>
              <Box className={styles.tble_hdng}>
                <Button
                // onClick={handleToggleThisYear}
                >
                  <img
                    src={assest.messageContentIcon}
                    width={14}
                    height={14}
                    alt=""
                  />
                  Message Content Buyer{" "}
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box className={styles.tble_hdng}>
                <Button
                // onClick={handleToggleThisYear}
                >
                  <img
                    src={assest.messageContentIcon}
                    width={14}
                    height={14}
                    alt=""
                  />
                  Message Member{" "}
                </Button>
              </Box>
              <Box className={styles.tble_hdng}>
                <Button
                onClick={()=> setOpenPartnerMessage(true)}
                >
                  <img
                    src={assest.messageContentIcon}
                    width={14}
                    height={14}
                    alt=""
                  />
                  Message Partner{" "}
                </Button>
              </Box>
            </>
          )}

          <Box className={styles.tble_hdng}>
            <Button
            // onClick={handleToggleThisYear1}
            >
              <img
                src={assest.messageContentIcon}
                width={14}
                height={14}
                alt=""
              />
              Message QC Agent{" "}
            </Button>
          </Box>

          <Box className={styles.tble_hdng}>
            <Button
            // onClick={handleToggleThisYear2}
            >
              <img
                src={assest.messageContentIcon}
                width={14}
                height={14}
                alt=""
              />
              Message Manager{" "}
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default VideoMessageSection;
